import React from 'react';
export default function OccupationalHealth() {
  return (
    <a style={{ color: 'black' }} href='tel:844-354-3705'>
      844-354-3705
    </a>
  );
}
